import AjaxService, { validateResponse } from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';
import { convertToFormData } from '../utils/helpers';

export const fetchFiles = ({ projectId, userId, taskId, folderId, offset = 0, limit = 15 }) => {
    return AjaxService({
        method: 'get',
        url: `files`,
        params: {
            project_id: projectId,
            user_id: userId,
            task_id: taskId,
            folder_id: folderId,
            offset,
            limit
        }
    })
    .then(response => validateResponse(response, 'files').data)
    .catch(handleServerError);
}

export const uploadFiles = (files, { project, task, doc, folder, folder_stack }, onProgress) => {
    return AjaxService({
        method: 'post',
        url: 'files',
        params: {
            project_id: project,
            task_id: task,
            doc_id: doc,
            folder_id: folder
        },
        data: convertToFormData({
            files,
            folder_stack: folder_stack ? JSON.stringify(folder_stack) : undefined
        }),
        onUploadProgress: progressEvent => {
            onProgress && onProgress(progressEvent.loaded, progressEvent.total);
        }
    })
    .then(response => (response.data.files || []).map(file => {
        file.originalDownload = file.download;
        file.thumbnail = null;
        file.url = null;
        file.download = null;
        return file;
    }))
    .catch(handleServerError);
}

export const fetchFile = fileId => {
    return AjaxService({
        method: 'get',
        url: `files/${fileId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeFile = fileId => {
    return AjaxService({
        method: 'delete',
        url: `files/${fileId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const checkStorageLimit = size => {
    return AjaxService({
        method: 'post',
        url: `teams/file_limits`,
        data: { size }
    })
    .then(response => response.data);
}

export const updateFile = (fileId, { archived, folder, folder_stack }) => {
    return AjaxService({
        method: 'put',
        url: `files/${fileId}`,
        data: {
            archived,
            folder_id: folder,
            folder_stack
        }
    }).then(response => response.data.data);
}

export const addFileLabels = (fileId, labels, configOnly) => {
    const requestConfig = {
        method: 'put',
        url: `files/${fileId}/labels`,
        data: { labels }
    };

    if (configOnly) {
        return requestConfig;
    }

    return AjaxService(requestConfig)
        .then(response => response.data)
        .catch(handleServerError);
}

export const removeFileLabels = (fileId, labels, configOnly) => {
    const requestConfig = {
        method: 'delete',
        url: `files/${fileId}/labels`,
        data: { labels }
    };

    if (configOnly) {
        return requestConfig;
    }

    return AjaxService(requestConfig)
        .then(response => response.data)
        .catch(handleServerError);
}

export const copyFile = (fileId, data) => {
    return AjaxService({
        method: 'post',
        url: `files/${fileId}/copy`,
        data
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const externalLoad = ({ project, task, doc, files, folder_id, folder_stack }) => {
    return AjaxService({
        method: 'post',
        url: 'files/download',
        data: {
            project_id: project,
            task_id: task,
            doc_id: doc,
            files,
            folder_id,
            folder_stack

        }
    }).then(response => response.data);
}
